import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogBodyProps } from './DialogBody.types';

const CannotTriggerAuditDialogBody = ({ name }: DialogBodyProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t('accessFunction.auditPopup.messageCannotBeAudit', { name })}
      <br />
      <br />
      {t('accessFunction.auditPopup.messageNotConfigured')}
    </Fragment>
  );
};

export default CannotTriggerAuditDialogBody;
